import { render, staticRenderFns } from "./Substatus.vue?vue&type=template&id=7099b016&"
import script from "./Substatus.vue?vue&type=script&lang=js&"
export * from "./Substatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports